import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-chevron-down.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const ChevronDownIcon = createSvgIcon(<Icon />, 'ChevronDownIcon');
